import Vector from "../math/Vector";

export default class SkillUtil {
    constructor() {}

    /**
     * @param {Vector} center 
     * @param {number} radius 
     * @param {number} radians 
     * @returns {Vector}
     */
    static projectPosition(center, radius, radians, outputPosition) {
        outputPosition.copy(center);

        outputPosition.x += Math.cos(radians) * radius;
        outputPosition.y += Math.sin(radians) * radius;

        return outputPosition;
    }

    /**
     * @param {Vector} position 
     * @param {GridTile[]} tiles 
     * @param {number} pixelRange2 
     */
    static findClosestTileInRange(position, tiles, pixelRange2) {
        if (tiles.length === 0) {
            return null;
        }

        let closestTile = null;
        let closestDist2 = 10000;

        for (let i = 0; i < tiles.length; i++) {
            const tile = tiles[i];
            if (!tile || tile.open) {
                continue;
            }

            const dist2 = position.distanceSquared(tile.origin);

            // Make sure the tile is in range.
            if (dist2 > pixelRange2) {
                continue;
            }

            if (!closestTile || dist2 < closestDist2) {
                closestTile = tile;
                closestDist2 = dist2;
            }
        }

        return closestTile;
    }

    /**
     * @param {Vector} position 
     * @param {GridTile[]} tiles 
     */
    static findClosestTile(position, tiles) {
        if (tiles.length === 0) {
            return null;
        }

        let closestTile = null;
        let closestDist2 = 10000;

        for (let i = 0; i < tiles.length; i++) {
            const tile = tiles[i];
            if (!tile || tile.open) {
                continue;
            }

            const dist2 = position.distanceSquared(tile.origin);

            if (!closestTile || dist2 < closestDist2) {
                closestTile = tile;
                closestDist2 = dist2;
            }
        }

        return closestTile;
    }


}